export default __webpack_public_path__ + "static/media/destroyed_46@2x.c1e0f270.png";